import { Component } from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import { selectUser } from 'services/Authentication/selectors';

import { TableHeader } from 'styles/common';
import { SettingsPageContent, SettingsTitle } from 'styles/settings';

export class Departments extends Component {
  handleSave = () => null;

  render() {
    return (
      <SettingsPageContent>
        <Helmet>
          <title>
            {/* @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message */}
            {this.props.intl.formatMessage({
              id: 'views.Settings.helmetTitle',
            })}
          </title>
          <meta
            name="settings"
            // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            content={this.props.intl.formatMessage({
              id: 'views.Settings.helmetDescription',
            })}
          />
        </Helmet>
        <TableHeader>
          <SettingsTitle>
            <FormattedMessage id="containers.PlatformSettings.sideMenuDepartments" />
          </SettingsTitle>
        </TableHeader>
      </SettingsPageContent>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  user: selectUser(),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
// @ts-expect-error TS(2345): Argument of type 'ConnectedComponent<FC<WithIntlPr... Remove this comment to see the full error message
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Departments)));
